import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ReviewSourceDisplay } from 'component/page/detail/Review/Review.selectors';

interface OwnProps {
    index: number;
    reviewId: number;
    reviewSource: ReviewSourceDisplay;
}

type Props = OwnProps;

const ReviewCardSource: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        <Box mt="16">
            <Typography variant="caption-default" textColor="base.subtle">
                {StringFormatter.formatToJsx(
                    cms[272061],
                    <Typography key={`${props.reviewId}-source-${props.index}`} variant="caption-default-strong" textColor="base.subtle">
                        {props.reviewSource}
                    </Typography>,
                )}
            </Typography>
        </Box>
    );
};

ReviewCardSource.displayName = 'ReviewCardSource';
export default ReviewCardSource;
